export const REQUEST_FLIGHT = 'REQUEST_FLIGHT'

export default (flightId: string) => ({
  type: REQUEST_FLIGHT,
  flightId,
})
